export default {
    LOAD_INVENTORIE(state, inventorie) {
        state.items = inventorie;
    }
}